import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { RETIREMENT_CALCULATOR_NAMESPACE } from './RetirementCalculator.const';
import { formatAmount } from './RetirementCalculator.utils';

export const useFormatAmount = () => {
  const [t] = useTranslation(RETIREMENT_CALCULATOR_NAMESPACE, { useSuspense: false });

  return useCallback(
    (value: number) => t('result.amount', '{{amount}} PLN', { amount: formatAmount(value) }),
    [t],
  );
};
